{"schemaVersion":1,"release":{"version":"1.0.11","build":159,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.0.11-159.dmg","sha256":"ca84c9b0ee12ccd2c442aac8ab7823d5f32b8dab4e15055c8edd9d2e83d52ff6","size":29103176}}
